import { Link } from "react-router-dom";

import { Middle, Paragraph, Spacing, Text, Button } from "@otta/design";
import { modularScale, palette } from "@otta/design-tokens";

export function RequiresEmailVerification({
  email,
}: {
  email?: string;
}): React.ReactElement {
  return (
    <Middle
      maxWidth={650}
      style={{ padding: `${modularScale(5)} ${modularScale()}` }}
    >
      <Spacing>
        <Text as="h2" size={3} bold>
          Verify your email
        </Text>
        <Paragraph>
          Thanks for signing up! Before you can access your account, please
          verify your email. We have sent an email to{" "}
          {email ? <b>{email}</b> : "you"}.
        </Paragraph>
        <Paragraph>
          No email in your inbox or spam folder?{" "}
          <Link to="/verify-email" style={{ color: palette.brand.black }}>
            Click here to resend
          </Link>
          .
        </Paragraph>

        <Button
          data-testid="logout-button"
          level="primary"
          as={Link}
          to="/logout"
        >
          Log out
        </Button>
      </Spacing>
    </Middle>
  );
}
